import React from 'react';
import PropTypes from 'prop-types';
import QueryEntityContent from './QueryEntityContent';
import ConversationEntityContent from './ConversationEntityContent';

const QueryEntity = ({
  queryEntity,
  entityInfos,
  conversationQuery,
  parentGroupId,
  index,
  onDeleteEntityRequest,
  onUpdateEntityRequest,
  onEntityDragToggle,
  onRequireMissingItemRequest,
  queryBuilderType,
  canDeleteRow = true,
}) => {
  return (
    <React.Fragment>
      {queryBuilderType !== 'conversation' ? (
        <QueryEntityContent
          queryEntity={queryEntity}
          entityInfos={entityInfos}
          parentGroupId={parentGroupId}
          index={index}
          onDeleteEntityRequest={onDeleteEntityRequest}
          onUpdateEntityRequest={onUpdateEntityRequest}
          onEntityDragToggle={onEntityDragToggle}
          onRequireMissingItemRequest={onRequireMissingItemRequest}
          canDeleteRow={canDeleteRow}
        />
      ) : (
        <ConversationEntityContent
          queryEntity={queryEntity}
          conversationQuery={conversationQuery}
          parentGroupId={parentGroupId}
          index={index}
          onEntityDragToggle={onEntityDragToggle}
          canDeleteRow={canDeleteRow}
        />
      )}
    </React.Fragment>
  );
};

QueryEntity.propsType = {
  queryEntity: PropTypes.shape({
    type: PropTypes.oneOf(['item', 'category', 'demographic']),
    class: PropTypes.oneOf(['gender', 'age']),
    id: PropTypes.string,
  }),
  entityInfos: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.oneOf(['item', 'category', 'demographic']),
    taxonomy: PropTypes.array,
  }),
  onEntityDelete: PropTypes.func,
  onEntityUpdate: PropTypes.func,
  queryBuilderType: PropTypes.string,
};

export default QueryEntity;
